import { useEffect, useState } from "react";
import {
  getOrderProductVariants,
  getProductBySlug,
} from "../../api/productVariants";

async function loadCatalog(shipInsureId, merchantId) {
  const { data: orderedVariants = [] } =
    await getOrderProductVariants(shipInsureId);
  const handles = [
    ...new Set(
      orderedVariants.map((variant) => variant.product_handle).filter(Boolean),
    ),
  ];
  const products = await Promise.all(
    handles.map((handle) =>
      getProductBySlug(merchantId, handle).then((response) => response.data),
    ),
  );

  const byProduct = {};
  products.forEach((product) => {
    byProduct[String(product.id)] = product.variants.map((variant) => ({
      ...variant,
      variant_id: variant.id,
    }));
  });
  return byProduct;
}

export function useExchangeCatalog(order) {
  const [catalog, setCatalog] = useState({});
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    if (
      !order?.allow_exchanges ||
      !order?.shipInsureID ||
      !order?.merchant_id
    ) {
      setCatalog({});
      setStatus("idle");
      return undefined;
    }

    let cancelled = false;
    setStatus("loading");
    loadCatalog(order.shipInsureID, order.merchant_id)
      .then((byProduct) => {
        if (cancelled) return;
        setCatalog(byProduct);
        setStatus("ready");
      })
      .catch(() => {
        if (!cancelled) {
          setCatalog({});
          setStatus("error");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [order?.allow_exchanges, order?.shipInsureID, order?.merchant_id]);

  return { catalog, status };
}
